export default __webpack_public_path__ + "static/media/display_full.a6bf0fc6.svg";